const delayFunc = async (sec) => {
  return new Promise((resolve) => setTimeout(resolve, sec * 1000));
};

export default delayFunc;
